// Every permission an employee can be granted directly. Keep in step with the
// server's PERMISSION_LABELS (server/routes/employees.js).

// The wildcard the permission checks already understand: holding it answers yes
// to every permission there is and every one added later. It is a grant in its
// own right, not the sum of the individual ones.
export const ADMIN_PERMISSION = '*';

export const PERMISSION_OPTIONS = [
  { label: 'Administrator (all permissions)', value: ADMIN_PERMISSION },
  { label: 'Approve Time Off', value: 'approve_time_off' },
  { label: 'View All Expenses', value: 'view_all_expenses' },
  { label: 'Approve Expenses', value: 'approve_expenses' },
  { label: 'Submit Expenses on Behalf of Another Employee', value: 'submit_expenses_on_behalf' },
  { label: 'Manage All Employees', value: 'manage_all_employees' },
  { label: 'Manage Coached Employees', value: 'manage_coached_employees' },
  { label: 'Manage Hiring', value: 'manage_hiring' },
  { label: 'Manage Payroll', value: 'manage_payroll' },
  { label: 'Manage Roles', value: 'manage_roles' },
  { label: 'Manage Resumes', value: 'manage_resumes' },
  { label: 'View TimeCamp Breakdown', value: 'view_timecamp_breakdown' },
  { label: 'Manage Timesheets', value: 'manage_timesheets' },
  { label: 'Approve Timesheets', value: 'approve_timesheets' },
  { label: 'View Timesheet Reports', value: 'view_timesheet_reports' },
  { label: 'Manage R&D Credits', value: 'manage_rd_credits' },
  { label: 'Manage Vendors & Customers', value: 'manage_expense_vendors' },
  { label: 'Manage Mileage Rates', value: 'manage_mileage_rates' },
  { label: 'Manage Onboarding', value: 'manage_onboarding' },
  { label: 'Can Create Surveys', value: 'create_surveys' },
  { label: 'Can Impersonate Employees', value: 'impersonate_employees' },
];

export const GRANTABLE_PERMISSIONS = PERMISSION_OPTIONS
  .map((option) => option.value)
  .filter((value) => value !== ADMIN_PERMISSION);

const isGrantsObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

export const toGrantedPermissionList = (grants) => (
  isGrantsObject(grants)
    ? PERMISSION_OPTIONS.map((option) => option.value).filter((key) => grants[key] === true)
    : []
);

// Administrator is stored on its own: writing today's individual keys beside it
// would pin the account to today's list, the opposite of what it means.
export const toPermissionGrantsObject = (selected) => {
  const list = (selected || []).filter(Boolean);
  if (list.includes(ADMIN_PERMISSION)) return { [ADMIN_PERMISSION]: true };
  return Object.fromEntries(list.map((permission) => [permission, true]));
};

// Whether an employee holds a permission, counting Administrator as holding all.
export const holdsPermission = (grants, permission) => (
  isGrantsObject(grants) && (grants[ADMIN_PERMISSION] === true || grants[permission] === true)
);
